var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var fieldnetTree = require('../../network/components/fieldnetTree');

var mod = Object.create(Model);

mod.name = 'Point';
mod['@class'] = 'Point';
mod.url = 'point';
mod.fields = {
  writeAlternatePoint: {
      default: ''
  }
};


mod.view = function () {
  return m(fieldnetTree, {selectedPoint: mod.form.writeAlternatePoint});
};

module.exports = mod;
